export default __webpack_public_path__ + "static/media/gwn25.4ac1ee28.webp";